document.addEventListener("DOMContentLoaded", () => {
  const homepageHeaderGroup = document.querySelector(".template-index .shopify-section-group-header-group");
  if (homepageHeaderGroup) {
    const syncHomepageHeaderOffset = () => {
      document.documentElement.style.setProperty(
        "--tbm-header-group-height",
        `${homepageHeaderGroup.getBoundingClientRect().height}px`
      );
    };

    syncHomepageHeaderOffset();
    window.addEventListener("resize", syncHomepageHeaderOffset);

    if ("ResizeObserver" in window) {
      const homepageHeaderObserver = new ResizeObserver(syncHomepageHeaderOffset);
      homepageHeaderObserver.observe(homepageHeaderGroup);
    }
  }

  const navToggle = document.querySelector("[data-nav-toggle]");
  const nav = document.querySelector("[data-nav]");
  const closeNavDropdowns = () => {
    document.querySelectorAll("[data-nav-dropdown]").forEach((dropdown) => {
      dropdown.classList.remove("is-open");
      const trigger = dropdown.querySelector("[data-nav-dropdown-trigger]");
      const menu = dropdown.querySelector("[data-nav-dropdown-menu]");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
      if (menu) menu.hidden = true;
    });
  };

  if (navToggle && nav) {
    navToggle.addEventListener("click", () => {
      const isOpen = nav.classList.toggle("is-open");
      navToggle.setAttribute("aria-expanded", String(isOpen));
      if (!isOpen) closeNavDropdowns();
    });

    nav.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        nav.classList.remove("is-open");
        navToggle.setAttribute("aria-expanded", "false");
        closeNavDropdowns();
      });
    });

    nav.querySelectorAll("[data-nav-dropdown-trigger]").forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const dropdown = trigger.closest("[data-nav-dropdown]");
        const menu = dropdown?.querySelector("[data-nav-dropdown-menu]");
        const isOpen = dropdown?.classList.contains("is-open");
        closeNavDropdowns();

        if (dropdown && menu && !isOpen) {
          dropdown.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
          menu.hidden = false;
        }
      });
    });

    document.addEventListener("click", (event) => {
      if (!event.target.closest("[data-nav]")) {
        closeNavDropdowns();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeNavDropdowns();
      }
    });
  }

  const showThemePopup = ({ eyebrow = "Notice", message = "", buttonText = "Got it" } = {}) => {
    let notice = document.querySelector("[data-theme-popup]");

    if (!notice) {
      notice = document.createElement("div");
      notice.className = "tbm-stock-notice";
      notice.setAttribute("role", "dialog");
      notice.setAttribute("aria-modal", "true");
      notice.setAttribute("aria-live", "polite");
      notice.dataset.themePopup = "";
      notice.innerHTML = `
        <div class="tbm-stock-notice__panel">
          <span class="tbm-stock-notice__eyebrow" data-theme-popup-eyebrow></span>
          <p class="tbm-stock-notice__message" data-theme-popup-message></p>
          <button class="tbm-stock-notice__button" type="button" data-theme-popup-close></button>
        </div>
      `;
      document.body.appendChild(notice);

      notice.addEventListener("click", (event) => {
        if (event.target === notice || event.target.closest("[data-theme-popup-close]")) {
          notice.classList.remove("is-visible");
        }
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          notice.classList.remove("is-visible");
        }
      });
    }

    const eyebrowNode = notice.querySelector("[data-theme-popup-eyebrow]");
    const messageNode = notice.querySelector("[data-theme-popup-message]");
    const closeButton = notice.querySelector("[data-theme-popup-close]");

    if (eyebrowNode) {
      eyebrowNode.textContent = eyebrow;
    }

    if (messageNode) {
      messageNode.textContent = message;
    }

    if (closeButton) {
      closeButton.textContent = buttonText;
    }

    notice.classList.add("is-visible");
    if (closeButton) closeButton.focus();
  };

  window.alert = (message) => {
    showThemePopup({ eyebrow: "Notice", message: String(message || "") });
  };

  window.tbmShowPopup = showThemePopup;

  document.querySelectorAll("[data-form-success]").forEach((message) => {
    showThemePopup({
      eyebrow: "Inquiry sent",
      message: message.textContent.trim() || "Thanks, your inquiry has been sent.",
    });
  });

  const setLoadingControl = (control, label = "Loading...") => {
    if (!control || control.classList.contains("is-loading")) return;

    const labelNode = control.querySelector("[data-loading-label]");

    if (labelNode) {
      control.dataset.defaultText = labelNode.textContent.trim();
      labelNode.textContent = label;
    } else {
      control.dataset.defaultText = control.textContent.trim();
      control.textContent = label;
    }

    control.classList.add("is-loading");
    control.setAttribute("aria-busy", "true");
    control.setAttribute("aria-disabled", "true");
    document.documentElement.classList.add("tbm-is-loading");
  };

  const showStockNotice = (limit, color, tire) => {
    if (!Number.isFinite(limit)) return;

    const displayColor = color || "selected";
    const displayTire = tire || "configuration";
    showThemePopup({
      eyebrow: "Inventory limit",
      message: `Only ${limit} ${displayColor} ${displayTire} left in stock`,
    });
  };

  document.querySelectorAll("[data-mode-tabs]").forEach((container) => {
    const buttons = container.querySelectorAll("[data-mode-trigger]");
    const panel = container.querySelector("[data-mode-panel]");

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        buttons.forEach((item) => {
          item.classList.remove("is-active");
          item.setAttribute("aria-selected", "false");
        });

        button.classList.add("is-active");
        button.setAttribute("aria-selected", "true");

        if (panel) {
          panel.querySelector("[data-mode-badge]").textContent = button.dataset.modeBadge || "";
          panel.querySelector("[data-mode-title]").textContent = button.dataset.modeTitle || "";
          panel.querySelector("[data-mode-copy]").textContent = button.dataset.modeCopy || "";
          panel.querySelector("[data-mode-list]").innerHTML = (button.dataset.modeList || "")
            .split("|")
            .map((item) => item.trim())
            .filter(Boolean)
            .map((item) => `<li>${item}</li>`)
            .join("");
        }
      });
    });
  });

  const closeCustomSelects = () => {
    document.querySelectorAll(".tbm-custom-select").forEach((element) => {
      element.classList.remove("is-open");
      const menu = element.querySelector(".tbm-custom-select__menu");
      if (menu) menu.hidden = true;
    });
  };

  document.querySelectorAll(".tbm-product-form__select select, .tbm-reserve-form select, .tbm-ride-booking__field select, [data-rider-roster] select").forEach((select) => {
    const wrapper = document.createElement("div");
    wrapper.className = "tbm-custom-select";

    const trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "tbm-custom-select__trigger";
    trigger.textContent = select.options[select.selectedIndex]?.text || "Select";

    const menu = document.createElement("div");
    menu.className = "tbm-custom-select__menu";
    menu.hidden = true;

    Array.from(select.options).forEach((option) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "tbm-custom-select__option";
      button.textContent = option.text;
      if (option.selected) button.classList.add("is-selected");
      if (option.disabled) button.disabled = true;

      button.addEventListener("click", () => {
        select.value = option.value;
        trigger.textContent = option.text;
        menu.querySelectorAll(".tbm-custom-select__option").forEach((item) => item.classList.remove("is-selected"));
        button.classList.add("is-selected");
        closeCustomSelects();
        select.dispatchEvent(new Event("change", { bubbles: true }));
      });

      menu.appendChild(button);
    });

    trigger.addEventListener("click", () => {
      const isOpen = !wrapper.classList.contains("is-open");
      closeCustomSelects();
      wrapper.classList.toggle("is-open", isOpen);
      menu.hidden = !isOpen;
    });

    select.parentNode.insertBefore(wrapper, select.nextSibling);
    wrapper.appendChild(trigger);
    wrapper.appendChild(menu);
  });

  document.querySelectorAll(".tbm-reserve-form").forEach((form) => {
    const typeSelect = form.querySelector("[data-inquiry-type-select]");
    const fields = form.querySelectorAll("[data-inquiry-field]");
    const tagInput = form.querySelector("input[name='contact[tags]']");
    const tagLabels = {
      general: "General Inquiry",
      influencer: "Influencer Inquiry",
      dealer: "Dealer Inquiry",
    };

    if (!typeSelect || !fields.length) return;

    const getInquiryType = () => {
      const value = (typeSelect.value || "general").toLowerCase();
      if (value.includes("dealer")) return "dealer";
      if (value.includes("influencer")) return "influencer";
      return "general";
    };

    const getControl = (field) => {
      return field.querySelector("input:not([type='hidden']), select, textarea");
    };

    const clearInvalidState = (field) => {
      field.classList.remove("is-invalid");
      const control = getControl(field);
      if (control) control.classList.remove("is-invalid");
    };

    const isFieldVisibleForType = (field, inquiryType) => {
      return (field.dataset.inquiryTypes || "").split(/\s+/).includes(inquiryType);
    };

    const syncInquiryFields = () => {
      const inquiryType = getInquiryType();

      if (tagInput && tagLabels[inquiryType]) {
        tagInput.value = tagLabels[inquiryType];
      }

      fields.forEach((field) => {
        const shouldShow = isFieldVisibleForType(field, inquiryType);
        const control = getControl(field);

        field.hidden = !shouldShow;
        field.classList.toggle("is-hidden", !shouldShow);
        field.style.display = shouldShow ? "" : "none";

        if (control) {
          control.disabled = !shouldShow;
          control.setAttribute("aria-required", String(shouldShow));
        }

        if (!shouldShow) clearInvalidState(field);
      });
    };

    const markInvalidField = (field) => {
      const control = getControl(field);
      field.classList.add("is-invalid");
      if (control) control.classList.add("is-invalid");

      window.setTimeout(() => {
        clearInvalidState(field);
      }, 2600);
    };

    const validateInquiryForm = () => {
      const missingFields = [];
      const visibleFields = Array.from(fields).filter((field) => !field.hidden);

      visibleFields.forEach((field) => {
        const control = getControl(field);
        if (!control) return;

        const value = (control.value || "").trim();
        const isMissing = value === "";
        const isInvalidEmail = control.type === "email" && value !== "" && !control.checkValidity();

        if (isMissing || isInvalidEmail) {
          missingFields.push(field);
          markInvalidField(field);
        }
      });

      if (!missingFields.length) return true;

      const labels = missingFields.map((field) => field.dataset.fieldLabel || "Required field");
      const firstControl = getControl(missingFields[0]);
      const customTrigger = missingFields[0].querySelector(".tbm-custom-select__trigger");

      showThemePopup({
        eyebrow: "Missing information",
        message: `Please fill out: ${labels.join(", ")}.`,
      });

      if (firstControl) {
        (customTrigger || firstControl).focus();
      }

      return false;
    };

    typeSelect.addEventListener("change", syncInquiryFields);
    form.addEventListener("input", (event) => {
      const field = event.target.closest("[data-inquiry-field]");
      if (field) clearInvalidState(field);
    });

    form.addEventListener("submit", (event) => {
      syncInquiryFields();

      if (!validateInquiryForm()) {
        event.preventDefault();
      }
    });

    syncInquiryFields();
  });

  document.querySelectorAll("[data-ride-booking]").forEach((booking) => {
    const form = booking.querySelector(".tbm-ride-booking__form");
    const grid = booking.querySelector("[data-booking-grid]");
    const monthLabel = booking.querySelector("[data-booking-month]");
    const prevButton = booking.querySelector("[data-booking-prev]");
    const nextButton = booking.querySelector("[data-booking-next]");
    const calendar = booking.querySelector("[data-booking-calendar]");
    const timeSection = booking.querySelector("[data-booking-times]");
    const timeGrid = booking.querySelector("[data-booking-time-grid]");
    const timeHelp = booking.querySelector("[data-booking-times-help]");
    const summaryDate = booking.querySelector("[data-booking-summary-date]");
    const summaryMeta = booking.querySelector("[data-booking-summary-meta]");
    const daysStat = booking.querySelector("[data-booking-days-stat]");
    const durationStat = booking.querySelector("[data-booking-duration-stat]");
    const venueStat = booking.querySelector("[data-booking-venue-stat]");
    const dateInput = booking.querySelector("[data-booking-date-input]");
    const dateIsoInput = booking.querySelector("[data-booking-date-iso-input]");
    const timeInput = booking.querySelector("[data-booking-time-input]");
    const durationInput = booking.querySelector("[data-booking-duration-input]");
    const testRideFields = booking.querySelector("[data-booking-test-fields]");
    const proRideFields = booking.querySelector("[data-booking-pro-fields]");
    const locationInput = booking.querySelector("[data-booking-location]");
    const bikeInput = booking.querySelector("[data-booking-bike]");
    const trackInput = booking.querySelector("[data-booking-track]");
    const proBikeInput = booking.querySelector("[data-booking-pro-bike]");
    const spotsInput = booking.querySelector("[data-booking-spots-input]");
    const bodyInput = booking.querySelector("[data-booking-body]");
    const submitButton = booking.querySelector("[data-booking-submit]");
    const notesInput = booking.querySelector("[data-booking-notes]");
    const nameInput = form?.querySelector("input[name='contact[name]']");
    const emailInput = form?.querySelector("input[name='contact[email]']");
    const phoneInput = form?.querySelector("input[name='contact[phone]']");
    const serviceInputs = booking.querySelectorAll("[data-booking-service-input]");
    const bookingFields = booking.querySelectorAll("[data-booking-field]");

    if (!form || !grid || !monthLabel || !timeGrid) return;

    const capacity = Math.max(1, Number(booking.dataset.capacity || 5) || 5);
    const weeksAhead = Math.max(1, Number(booking.dataset.weeksAhead || 8) || 8);
    const testTimeSlots = (booking.dataset.testTimeSlots || "12:00 PM|1:00 PM|2:00 PM|3:00 PM|4:00 PM")
      .split("|")
      .map((time) => time.trim())
      .filter(Boolean);
    const proDateSlotKey = "Date only";
    const proMinDaysAhead = Math.max(1, Number(booking.dataset.proMinDaysAhead || 7) || 7);
    const durationMinutes = Math.max(1, Number(booking.dataset.durationMinutes || 60) || 60);
    const durationLabel = durationMinutes === 60 ? "1 hour" : `${durationMinutes} minutes`;
    const bookingLocation = booking.dataset.bookingLocation || "Los Angeles, CA";
    const parsedAvailableWeekdays = (booking.dataset.availableWeekdays || "1,5,6")
      .split(",")
      .map((day) => Number(day.trim()))
      .filter((day) => Number.isFinite(day) && day >= 0 && day <= 6);
    const testAvailableWeekdays = parsedAvailableWeekdays.length ? parsedAvailableWeekdays : [1, 5, 6];
    const proAvailableWeekdays = [0, 1, 2, 3, 4, 5, 6];
    const weekdayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const testAvailableDaysLabel = booking.dataset.availableDaysLabel || testAvailableWeekdays
      .map((day) => weekdayLabels[day])
      .filter(Boolean)
      .join(" / ");
    const proAvailableDaysLabel = "7+ days ahead";
    const storageBaseKey = `tbmRideBookings:${booking.id || "default"}`;
    const pendingKey = `${storageBaseKey}:pending`;
    const getCurrentServiceKey = () => {
      const selected = Array.from(serviceInputs).find((input) => input.checked);
      return selected?.value === "Learn from a pro rider" ? "pro" : "test";
    };
    const getStorageKey = (serviceKey = getCurrentServiceKey()) => `${storageBaseKey}:${serviceKey}`;
    const getCurrentTimeSlots = () => getCurrentServiceKey() === "pro"
      ? [proDateSlotKey]
      : testTimeSlots;
    const getAvailabilityTime = () => getCurrentServiceKey() === "pro"
      ? proDateSlotKey
      : selectedTime;
    const getCurrentAvailableWeekdays = () => getCurrentServiceKey() === "pro"
      ? proAvailableWeekdays
      : testAvailableWeekdays;
    const getCurrentAvailableDaysLabel = () => getCurrentServiceKey() === "pro"
      ? proAvailableDaysLabel
      : testAvailableDaysLabel;
    const getDateSelectionPrompt = () => getCurrentServiceKey() === "pro"
      ? "Choose a date at least 7 days in advance."
      : `Choose an available ${testAvailableDaysLabel} session.`;
    const dateFormatter = new Intl.DateTimeFormat(undefined, {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
    const monthFormatter = new Intl.DateTimeFormat(undefined, {
      month: "long",
      year: "numeric",
    });
    const statDateFormatter = new Intl.DateTimeFormat(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
    const todayNow = new Date();
    const today = new Date(todayNow.getFullYear(), todayNow.getMonth(), todayNow.getDate());
    const proMinBookableDate = new Date(today);
    proMinBookableDate.setDate(today.getDate() + proMinDaysAhead);
    const getLastBookableDate = () => {
      const date = new Date(today);
      date.setDate(today.getDate() + (weeksAhead * 7));
      return date;
    };
    const minMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const getMaxMonth = () => {
      const lastBookableDate = getLastBookableDate();
      return new Date(lastBookableDate.getFullYear(), lastBookableDate.getMonth(), 1);
    };
    let visibleMonth = new Date(minMonth);
    let selectedDateKey = "";
    let selectedDateLabel = "";
    let selectedDateStatLabel = "";
    let selectedTime = "";
    let activeServiceKey = getCurrentServiceKey();

    const parseBookedSlots = (serializedSlots) => {
      try {
        const parsed = JSON.parse(serializedSlots || "{}");
        if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};

        return parsed;
      } catch (error) {
        return {};
      }
    };

    const testBookedSlots = parseBookedSlots(booking.dataset.testBookedSlots);
    const proBookedSlots = parseBookedSlots(booking.dataset.proBookedSlots);

    const readStoredBookings = (serviceKey = getCurrentServiceKey()) => {
      try {
        const stored = window.localStorage.getItem(getStorageKey(serviceKey));
        const parsed = stored ? JSON.parse(stored) : {};
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
      } catch (error) {
        return {};
      }
    };

    const writeStoredBookings = (bookings, serviceKey = getCurrentServiceKey()) => {
      try {
        window.localStorage.setItem(getStorageKey(serviceKey), JSON.stringify(bookings));
      } catch (error) {
        // Local storage is only used as a frontend capacity preview.
      }
    };

    const getDateKey = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const getBookingKey = (dateKey, time) => `${dateKey}::${time}`;

    const getManualBookingCount = (dateKey, time, serviceKey = getCurrentServiceKey()) => {
      const bookedSlots = serviceKey === "pro" ? proBookedSlots : testBookedSlots;
      const flatCount = Number(bookedSlots[getBookingKey(dateKey, time)]);
      const dateEntry = bookedSlots[dateKey];
      const nestedCount = dateEntry && typeof dateEntry === "object"
        ? Number(dateEntry[time])
        : Number(dateEntry);
      const count = Number.isFinite(flatCount) ? flatCount : nestedCount;
      return Number.isFinite(count) ? Math.max(0, count) : 0;
    };

    const getStoredBookingCount = (dateKey, time, serviceKey = getCurrentServiceKey()) => {
      const stored = readStoredBookings(serviceKey);
      const count = Number(stored[getBookingKey(dateKey, time)] || 0);
      return Number.isFinite(count) ? count : 0;
    };

    const getUsedSpots = (dateKey, time, serviceKey = getCurrentServiceKey()) => {
      return getManualBookingCount(dateKey, time, serviceKey)
        + getStoredBookingCount(dateKey, time, serviceKey);
    };

    const getSpotsLeft = (dateKey, time, serviceKey = getCurrentServiceKey()) => {
      return Math.max(0, capacity - getUsedSpots(dateKey, time, serviceKey));
    };

    const getSpotsLabel = (count) => {
      return `${count} ${count === 1 ? "spot" : "spots"}`;
    };

    const getTimeHour = (time) => {
      const match = time.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
      if (!match) return 0;

      let hour = Number(match[1]) % 12;
      if (match[3].toUpperCase() === "PM") hour += 12;
      return hour;
    };

    const isPastTimeSlot = (date, time) => {
      const now = new Date();
      const currentDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const isPastDate = date.getTime() < currentDay.getTime();
      const isToday = date.getTime() === currentDay.getTime();
      const isPastTodaySlot = isToday && (
        now.getHours() > getTimeHour(time)
        || (now.getHours() === getTimeHour(time) && now.getMinutes() >= 0)
      );
      return isPastDate || isPastTodaySlot;
    };

    const isBookableDate = (date) => {
      const timeSlots = getCurrentTimeSlots();
      const availableWeekdays = getCurrentAvailableWeekdays();
      const isAvailableDay = availableWeekdays.includes(date.getDay());
      const isInWindow = getCurrentServiceKey() === "pro"
        || date.getTime() <= getLastBookableDate().getTime();
      const meetsAdvanceNotice = getCurrentServiceKey() !== "pro"
        || date.getTime() >= proMinBookableDate.getTime();
      return isAvailableDay
        && isInWindow
        && meetsAdvanceNotice
        && timeSlots.some((time) => !isPastTimeSlot(date, time) && getSpotsLeft(getDateKey(date), time) > 0);
    };

    const getSelectedService = () => {
      const selected = Array.from(serviceInputs).find((input) => input.checked);
      return selected ? selected.value : "Test ride the bike";
    };

    const isProSession = () => getSelectedService() === "Learn from a pro rider";

    const getSelectedVenue = () => {
      return isProSession()
        ? trackInput?.value || "Lake Elsinore Raceway"
        : locationInput?.value || bookingLocation;
    };

    const getSessionDescription = () => {
      if (isProSession()) {
        return `${proBikeInput?.value || "Omega"} pro session at ${getSelectedVenue()} - time confirmed after request`;
      }

      return `${durationLabel} test ride in ${getSelectedVenue()} - ${bikeInput?.value || "Omega"}`;
    };

    const updateBookingBody = () => {
      if (!bodyInput) return;

      const name = form.querySelector("input[name='contact[name]']")?.value.trim() || "";
      const email = form.querySelector("input[name='contact[email]']")?.value.trim() || "";
      const phone = form.querySelector("input[name='contact[phone]']")?.value.trim() || "";
      const availabilityTime = getAvailabilityTime();
      const spotsLeft = selectedDateKey && availabilityTime
        ? getSpotsLeft(selectedDateKey, availabilityTime)
        : "";
      const notes = notesInput ? notesInput.value.trim() : "";
      const serviceDetails = isProSession()
        ? [
            `Track: ${trackInput?.value || "Lake Elsinore Raceway"}`,
            `Bike: ${proBikeInput?.value || "Omega"}`,
          ]
        : [
            `Location: ${locationInput?.value || bookingLocation}`,
            `Bike: ${bikeInput?.value || "Omega"}`,
          ];
      const scheduleDetails = isProSession()
        ? ["Scheduling: Date only; time confirmed after request"]
        : [
            `Time: ${selectedTime || "Not selected"}`,
            `Duration: ${durationLabel}`,
          ];
      const lines = [
        "Ride booking request",
        `Experience: ${getSelectedService()}`,
        ...serviceDetails,
        `Date: ${selectedDateLabel || "Not selected"}`,
        ...scheduleDetails,
        selectedDateKey && availabilityTime ? `Spots left before request: ${getSpotsLabel(spotsLeft)}` : "",
        name ? `Name: ${name}` : "",
        email ? `Email: ${email}` : "",
        phone ? `Phone: ${phone}` : "",
        notes ? `Notes: ${notes}` : "",
      ].filter(Boolean);

      bodyInput.value = lines.join("\n");
    };

    const hasRequiredContactInfo = () => {
      const hasName = (nameInput?.value || "").trim() !== "";
      const hasEmail = (emailInput?.value || "").trim() !== "" && emailInput.checkValidity();
      const hasPhone = (phoneInput?.value || "").trim() !== "";
      return hasName && hasEmail && hasPhone;
    };

    const syncSelection = () => {
      const isPro = isProSession();
      const availabilityTime = getAvailabilityTime();
      const spotsLeft = selectedDateKey && availabilityTime
        ? getSpotsLeft(selectedDateKey, availabilityTime)
        : capacity;

      if (dateInput) dateInput.value = selectedDateLabel;
      if (dateIsoInput) dateIsoInput.value = selectedDateKey;
      if (timeInput) timeInput.value = isPro ? "To be confirmed" : selectedTime;
      if (durationInput) durationInput.value = isPro ? "Date only; time to be confirmed" : durationLabel;
      if (spotsInput) spotsInput.value = selectedDateKey && availabilityTime ? String(spotsLeft) : "";
      const availableDaysLabel = getCurrentAvailableDaysLabel();
      if (daysStat) daysStat.textContent = selectedDateStatLabel || availableDaysLabel;
      if (durationStat) {
        durationStat.textContent = isPro
          ? "Date only"
          : selectedTime ? `${durationLabel} at ${selectedTime}` : durationLabel;
      }
      if (venueStat) venueStat.textContent = getSelectedVenue();

      if (summaryDate) {
        if (isPro && selectedDateKey) {
          summaryDate.textContent = selectedDateLabel;
        } else if (selectedDateKey && selectedTime) {
          summaryDate.textContent = `${selectedDateLabel} at ${selectedTime}`;
        } else if (selectedDateKey) {
          summaryDate.textContent = `${selectedDateLabel} — choose a time`;
        } else {
          summaryDate.textContent = getDateSelectionPrompt();
        }
      }

      if (summaryMeta) {
        summaryMeta.textContent = selectedDateKey && availabilityTime
          ? `${getSessionDescription()}; ${getSpotsLabel(spotsLeft)} left.`
          : `${getSessionDescription()}.`;
      }

      if (submitButton) {
        submitButton.disabled = !selectedDateKey
          || (!isPro && !selectedTime)
          || !hasRequiredContactInfo()
          || spotsLeft <= 0;
      }

      updateBookingBody();
    };

    const clearInvalidField = (field) => {
      field.classList.remove("is-invalid");
      const control = field.querySelector("input, select, textarea");
      if (control) control.classList.remove("is-invalid");
    };

    const markInvalidField = (field) => {
      field.classList.add("is-invalid");
      const control = field.querySelector("input, select, textarea");
      if (control) control.classList.add("is-invalid");

      window.setTimeout(() => {
        clearInvalidField(field);
      }, 2600);
    };

    const getSelectedDate = () => {
      if (!selectedDateKey) return null;
      const [year, month, day] = selectedDateKey.split("-").map(Number);
      return new Date(year, month - 1, day);
    };

    const renderTimeSlots = () => {
      const selectedDate = getSelectedDate();
      const timeSlots = getCurrentTimeSlots();
      timeGrid.innerHTML = "";
      if (timeSection) timeSection.hidden = isProSession();
      if (isProSession()) return;

      if (!selectedDate) {
        if (timeHelp) {
          timeHelp.textContent = "Select an available date to see its one-hour session times.";
        }
        return;
      }

      if (timeHelp) {
        timeHelp.textContent = `Available one-hour start times for ${selectedDateLabel}.`;
      }

      timeSlots.forEach((time) => {
        const spotsLeft = getSpotsLeft(selectedDateKey, time);
        const isPast = isPastTimeSlot(selectedDate, time);
        const isFull = spotsLeft <= 0;
        const isSelected = selectedTime === time;
        const button = document.createElement("button");
        const label = document.createElement("strong");
        const meta = document.createElement("span");

        button.type = "button";
        button.className = "tbm-ride-booking__time";
        button.setAttribute("aria-pressed", String(isSelected));
        button.disabled = isPast || isFull;
        if (isSelected) button.classList.add("is-selected");

        label.textContent = time;
        meta.textContent = isPast ? "Past" : isFull ? "Sold out" : durationLabel;
        button.setAttribute(
          "aria-label",
          isPast || isFull
            ? `${time}, unavailable`
            : `${time}, ${durationLabel}, ${getSpotsLabel(spotsLeft)} left`
        );

        button.appendChild(label);
        button.appendChild(meta);
        button.addEventListener("click", () => {
          if (isPast || isFull) return;
          selectedTime = time;
          if (timeSection) timeSection.classList.remove("is-invalid");
          syncSelection();
          renderTimeSlots();
        });
        timeGrid.appendChild(button);
      });
    };

    const renderCalendar = () => {
      const year = visibleMonth.getFullYear();
      const month = visibleMonth.getMonth();
      const timeSlots = getCurrentTimeSlots();
      const availableWeekdays = getCurrentAvailableWeekdays();
      const lastBookableDate = getLastBookableDate();
      const maxMonth = getMaxMonth();
      const isProCalendar = getCurrentServiceKey() === "pro";
      const firstDay = new Date(year, month, 1).getDay();
      const daysInMonth = new Date(year, month + 1, 0).getDate();

      monthLabel.textContent = monthFormatter.format(visibleMonth);
      grid.innerHTML = "";

      for (let index = 0; index < firstDay; index += 1) {
        const empty = document.createElement("span");
        empty.className = "tbm-calendar-day--empty";
        empty.setAttribute("aria-hidden", "true");
        grid.appendChild(empty);
      }

      for (let day = 1; day <= daysInMonth; day += 1) {
        const date = new Date(year, month, day);
        const dateKey = getDateKey(date);
        const dateLabel = dateFormatter.format(date);
        const proSpotsLeft = getSpotsLeft(dateKey, proDateSlotKey);
        const availableTimes = timeSlots.filter(
          (time) => !isPastTimeSlot(date, time) && getSpotsLeft(dateKey, time) > 0
        );
        const isAvailable = isBookableDate(date);
        const meetsAdvanceNotice = !isProCalendar || date.getTime() >= proMinBookableDate.getTime();
        const isEligibleDay = availableWeekdays.includes(date.getDay())
          && (isProCalendar || date.getTime() <= lastBookableDate.getTime())
          && meetsAdvanceNotice
          && timeSlots.some((time) => !isPastTimeSlot(date, time));
        const isSoldOut = isEligibleDay && availableTimes.length === 0;
        const isSelected = selectedDateKey === dateKey;
        const button = document.createElement("button");
        const number = document.createElement("span");
        const status = document.createElement("span");

        button.type = "button";
        button.className = "tbm-calendar-day";
        button.dataset.dateKey = dateKey;
        button.dataset.dateLabel = dateLabel;
        button.setAttribute("aria-pressed", String(isSelected));

        if (isAvailable) button.classList.add("is-available");
        if (isSoldOut) button.classList.add("is-sold-out");
        if (isSelected) button.classList.add("is-selected");

        if (!isAvailable || isSoldOut) {
          button.disabled = true;
        }

        number.className = "tbm-calendar-day__number";
        number.textContent = String(day);

        status.className = "tbm-calendar-day__status";
        if (isSoldOut) {
          status.textContent = "Sold out";
        } else if (isAvailable) {
          status.textContent = isProCalendar
            ? getSpotsLabel(proSpotsLeft)
            : `${availableTimes.length} ${availableTimes.length === 1 ? "slot" : "slots"}`;
        } else if (timeSlots.every((time) => isPastTimeSlot(date, time))) {
          status.textContent = "Past";
        } else {
          status.textContent = "Closed";
        }

        button.setAttribute(
          "aria-label",
          isAvailable && !isSoldOut
            ? isProCalendar
              ? `${dateLabel}, ${getSpotsLabel(proSpotsLeft)} available`
              : `${dateLabel}, ${availableTimes.length} available ${availableTimes.length === 1 ? "slot" : "slots"}`
            : `${dateLabel}, unavailable`
        );

        button.appendChild(number);
        button.appendChild(status);
        button.addEventListener("click", () => {
          if (!isAvailable || isSoldOut) return;

          selectedDateKey = dateKey;
          selectedDateLabel = dateLabel;
          selectedDateStatLabel = statDateFormatter.format(date);
          selectedTime = "";
          if (calendar) calendar.classList.remove("is-invalid");
          syncSelection();
          renderCalendar();
          renderTimeSlots();
        });

        grid.appendChild(button);
      }

      if (prevButton) {
        prevButton.disabled = visibleMonth.getTime() <= minMonth.getTime();
      }

      if (nextButton) {
        nextButton.disabled = !isProCalendar && visibleMonth.getTime() >= maxMonth.getTime();
      }
    };

    const syncServiceChoices = () => {
      const showProFields = isProSession();
      const nextServiceKey = getCurrentServiceKey();
      const serviceChanged = activeServiceKey !== nextServiceKey;
      activeServiceKey = nextServiceKey;

      serviceInputs.forEach((input) => {
        const choice = input.closest(".tbm-ride-booking__choice");
        if (choice) choice.classList.toggle("is-selected", input.checked);
      });

      if (testRideFields) testRideFields.hidden = showProFields;
      if (proRideFields) proRideFields.hidden = !showProFields;

      testRideFields?.querySelectorAll("select").forEach((control) => {
        control.disabled = showProFields;
      });
      proRideFields?.querySelectorAll("select").forEach((control) => {
        control.disabled = !showProFields;
      });

      if (serviceChanged) {
        selectedDateKey = "";
        selectedDateLabel = "";
        selectedDateStatLabel = "";
        selectedTime = "";
        visibleMonth = new Date(minMonth);
        if (calendar) calendar.classList.remove("is-invalid");
        if (timeSection) timeSection.classList.remove("is-invalid");
        renderCalendar();
        renderTimeSlots();
      }

      syncSelection();
    };

    const validateBookingForm = () => {
      if (!selectedDateKey) {
        if (calendar) {
          calendar.classList.add("is-invalid");
          calendar.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        showThemePopup({
          eyebrow: "Choose a date",
          message: getCurrentServiceKey() === "pro"
            ? "Please select a date at least seven days in advance."
            : `Please select an available ${testAvailableDaysLabel} session.`,
        });
        return false;
      }

      if (!isProSession() && !selectedTime) {
        if (timeSection) {
          timeSection.classList.add("is-invalid");
          timeSection.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        showThemePopup({
          eyebrow: "Choose a time",
          message: "Please select an available one-hour session time.",
        });
        return false;
      }

      const availabilityTime = getAvailabilityTime();
      if (getSpotsLeft(selectedDateKey, availabilityTime) <= 0) {
        showThemePopup({
          eyebrow: "Session full",
          message: "That session time is full. Please choose another available time.",
        });
        renderCalendar();
        renderTimeSlots();
        syncSelection();
        return false;
      }

      const missingFields = [];

      bookingFields.forEach((field) => {
        const control = field.querySelector("[data-booking-required]");
        if (!control || control.disabled) return;

        const value = (control.value || "").trim();
        const isInvalidEmail = control.type === "email" && value !== "" && !control.checkValidity();

        if (value === "" || isInvalidEmail) {
          missingFields.push(field);
          markInvalidField(field);
        }
      });

      if (!missingFields.length) return true;

      const labels = missingFields.map((field) => field.dataset.fieldLabel || "Required field");
      const firstControl = missingFields[0].querySelector("input, select, textarea");

      showThemePopup({
        eyebrow: "Missing information",
        message: `Please fill out: ${labels.join(", ")}.`,
      });

      if (firstControl) firstControl.focus();
      return false;
    };

    const commitSuccessfulBooking = () => {
      if (!booking.querySelector("[data-booking-form-success]")) return;

      try {
        const pendingBooking = JSON.parse(window.sessionStorage.getItem(pendingKey) || "null");
        if (!pendingBooking?.dateKey || !pendingBooking?.time || !pendingBooking?.serviceKey) return;

        const stored = readStoredBookings(pendingBooking.serviceKey);
        const bookingKey = getBookingKey(pendingBooking.dateKey, pendingBooking.time);
        const manuallyBooked = getManualBookingCount(
          pendingBooking.dateKey,
          pendingBooking.time,
          pendingBooking.serviceKey
        );
        const remainingLocalCapacity = Math.max(0, capacity - manuallyBooked);
        stored[bookingKey] = Math.min(remainingLocalCapacity, Number(stored[bookingKey] || 0) + 1);
        writeStoredBookings(stored, pendingBooking.serviceKey);
        window.sessionStorage.removeItem(pendingKey);
      } catch (error) {
        // The request was sent; storage is just a frontend display aid.
      }
    };

    if (prevButton) {
      prevButton.addEventListener("click", () => {
        visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() - 1, 1);
        renderCalendar();
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() + 1, 1);
        renderCalendar();
      });
    }

    serviceInputs.forEach((input) => {
      input.addEventListener("change", syncServiceChoices);
    });

    [locationInput, bikeInput, trackInput, proBikeInput].forEach((control) => {
      if (control) control.addEventListener("change", syncSelection);
    });

    form.addEventListener("input", (event) => {
      const field = event.target.closest("[data-booking-field]");
      if (field) clearInvalidField(field);
      syncSelection();
    });

    form.addEventListener("submit", (event) => {
      updateBookingBody();

      if (!validateBookingForm()) {
        event.preventDefault();
        return;
      }

      try {
        window.sessionStorage.setItem(pendingKey, JSON.stringify({
          dateKey: selectedDateKey,
          time: getAvailabilityTime(),
          serviceKey: getCurrentServiceKey(),
        }));
      } catch (error) {
        // If session storage is blocked, the contact request can still submit.
      }

      setLoadingControl(submitButton, "Sending...");
    });

    commitSuccessfulBooking();
    syncServiceChoices();
    syncSelection();
    renderCalendar();
    renderTimeSlots();
  });

  document.querySelectorAll("[data-rider-roster]").forEach((roster) => {
    const select = roster.querySelector("[data-rider-select]");
    const grid = roster.parentElement?.querySelector("[data-rider-roster-grid]");

    if (!select || !grid) return;

    const profiles = grid.querySelectorAll("[data-rider-profile]");

    const syncRiderProfile = () => {
      const selectedId = select.value;

      profiles.forEach((profile) => {
        const isActive = profile.dataset.riderProfile === selectedId;
        profile.hidden = !isActive;
        profile.classList.toggle("is-hidden", !isActive);
      });
    };

    select.addEventListener("change", syncRiderProfile);
    syncRiderProfile();
  });

  document.querySelectorAll("[data-video-library]").forEach((library) => {
    const section = library.closest(".tbm-videos-page");
    const cards = library.querySelectorAll("[data-video-card]");
    const filterButtons = section ? section.querySelectorAll("[data-video-filter]") : document.querySelectorAll("[data-video-filter]");
    const emptyState = library.querySelector("[data-video-empty]");
    const toggleTopButton = library.querySelector("[data-video-toggle-top]");
    let activeVideoType = "short";

    const stopVideo = (card) => {
      const frame = card.querySelector("[data-video-frame]");
      if (!frame) return;

      frame.removeAttribute("src");
      card.classList.remove("is-playing");
    };

    const stopAllVideos = () => {
      cards.forEach((card) => stopVideo(card));
    };

    const playVideo = (card) => {
      const frame = card.querySelector("[data-video-frame]");
      const src = frame?.dataset.videoSrc;

      if (!frame || !src) {
        showThemePopup({
          eyebrow: "Video unavailable",
          message: "Add a YouTube or Vimeo URL for this video in the Shopify editor.",
        });
        return;
      }

      cards.forEach((item) => {
        if (item !== card) stopVideo(item);
      });

      const requestPlayback = () => {
        if (!frame.contentWindow) return;

        if (src.includes("youtube.com")) {
          frame.contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "playVideo",
            args: [],
          }), "*");
        }

        if (src.includes("vimeo.com")) {
          frame.contentWindow.postMessage(JSON.stringify({
            method: "play",
          }), "*");
        }
      };

      frame.addEventListener("load", requestPlayback, { once: true });
      frame.src = src;
      card.classList.add("is-playing");
      frame.focus();
      window.setTimeout(requestPlayback, 500);
      window.setTimeout(requestPlayback, 1200);
    };

    cards.forEach((card) => {
      const playButton = card.querySelector("[data-video-play]");
      if (!playButton) return;

      playButton.addEventListener("click", () => playVideo(card));
    });

    library.querySelectorAll("[data-video-external]").forEach((link) => {
      link.addEventListener("click", (event) => {
        const href = link.getAttribute("href");
        if (!href) return;

        event.preventDefault();
        stopAllVideos();
        window.open(href, "_blank", "noopener,noreferrer");
      });
    });

    const syncVideoFilter = (type) => {
      let visibleCount = 0;
      activeVideoType = type;

      cards.forEach((card) => {
        const isVisible = card.dataset.videoType === type;
        if (!isVisible) stopVideo(card);
        card.hidden = !isVisible;
        card.classList.toggle("is-hidden", !isVisible);
        if (isVisible) visibleCount += 1;
      });

      if (emptyState) emptyState.hidden = visibleCount > 0;

      if (toggleTopButton) {
        toggleTopButton.textContent = type === "video" ? "View Shorts" : "View Videos";
      }
    };

    const activateVideoFilter = (type) => {
      filterButtons.forEach((item) => {
        const isActive = item.dataset.videoFilter === type;
        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-selected", String(isActive));
      });

      syncVideoFilter(type);
    };

    filterButtons.forEach((button) => {
      button.addEventListener("click", () => {
        activateVideoFilter(button.dataset.videoFilter || "video");
      });
    });

    if (toggleTopButton) {
      toggleTopButton.addEventListener("click", (event) => {
        event.preventDefault();
        const nextType = activeVideoType === "video" ? "short" : "video";
        activateVideoFilter(nextType);

        const target = document.querySelector(toggleTopButton.getAttribute("href"));
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }

    activateVideoFilter("short");
  });

  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    const activeImage = gallery.querySelector("[data-product-gallery-active]");
    const thumbs = Array.from(gallery.querySelectorAll("[data-product-gallery-thumb]"));
    const navButtons = gallery.querySelectorAll("[data-product-gallery-nav]");

    if (!activeImage || !thumbs.length) return;

    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains("is-active")));

    const setActiveImage = (index) => {
      activeIndex = (index + thumbs.length) % thumbs.length;
      const activeThumb = thumbs[activeIndex];
      const nextSrc = activeThumb.dataset.gallerySrc;

      if (!nextSrc) return;

      activeImage.src = nextSrc;
      activeImage.alt = activeThumb.dataset.galleryAlt || activeImage.alt || "";

      thumbs.forEach((item, itemIndex) => {
        const isActive = itemIndex === activeIndex;
        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-current", String(isActive));
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        setActiveImage(thumbs.indexOf(thumb));
      });
    });

    navButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const direction = button.dataset.productGalleryNav === "previous" ? -1 : 1;
        setActiveImage(activeIndex + direction);
      });
    });

    setActiveImage(activeIndex);
  });

  document.querySelectorAll("[data-product-search]").forEach((search) => {
    const form = search.querySelector("[data-product-search-form]");
    const input = search.querySelector("[data-product-search-input]");
    const cards = search.querySelectorAll("[data-product-card]");
    const count = search.querySelector("[data-product-search-count]");
    const empty = search.querySelector("[data-product-search-empty]");

    if (!input || !cards.length) return;

    const getProductsLabel = (value) => `${value} ${value === 1 ? "product" : "products"}`;

    const filterProducts = () => {
      const terms = input.value
        .trim()
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean);
      let visibleCount = 0;

      cards.forEach((card) => {
        const text = (card.dataset.productSearchText || "").toLowerCase();
        const isVisible = terms.every((term) => text.includes(term));
        card.hidden = !isVisible;
        card.classList.toggle("is-hidden", !isVisible);
        if (isVisible) visibleCount += 1;
      });

      if (count) {
        count.textContent = terms.length ? `${getProductsLabel(visibleCount)} found` : getProductsLabel(cards.length);
      }

      if (empty) {
        empty.hidden = visibleCount > 0;
      }
    };

    if (form) {
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        filterProducts();
      });
    }

    input.addEventListener("input", filterProducts);
    filterProducts();
  });

  document.querySelectorAll("[data-variant-picker]").forEach((picker) => {
    const select = picker.querySelector("[data-variant-select]");
    const variantCards = picker.querySelectorAll("[data-variant-card]");
    const optionChoices = picker.querySelectorAll("[data-option-choice]");
    const form = picker.closest("form");
    const buyArea = picker.closest(".tbm-buy-card, .tbm-omega-configurator");
    const price = buyArea ? buyArea.querySelector("[data-product-price]") : null;
    const comparePrice = buyArea ? buyArea.querySelector("[data-product-compare-price]") : null;
    const discountLabel = buyArea ? buyArea.querySelector("[data-product-discount-label]") : null;
    const status = buyArea ? buyArea.querySelector("[data-product-status]") : null;
    const fulfillmentNote = buyArea ? buyArea.querySelector("[data-product-fulfillment-note]") : null;
    const shippingTimelineInput = form ? form.querySelector("[data-shipping-timeline-input]") : null;
    const fulfillmentTypeInput = form ? form.querySelector("[data-fulfillment-type-input]") : null;
    const submitButtons = form ? Array.from(form.querySelectorAll("button[type='submit']")) : [];
    const submit = submitButtons[0] || null;
    const graphicsPreview = buyArea ? buyArea.querySelector("[data-graphics-preview]") : null;
    const configImage = graphicsPreview ? graphicsPreview.querySelector("[data-config-image]") : null;
    const isOmegaConfigurator = picker.closest(".tbm-omega-configurator") !== null;
    const cartHasPreorderBike = form?.querySelector("[data-cart-has-preorder-bike]")?.value === "true";
    const cartHasInStockBike = form?.querySelector("[data-cart-has-in-stock-bike]")?.value === "true";
    const isBikeProduct = form?.querySelector("[data-product-class]")?.value === "bike";
    const isOmegaRexProduct = form?.querySelector("[data-product-is-omega-rex]")?.value === "true";

    if (!select) return;

    const syncSubmitButtons = (canOrder) => {
      submitButtons.forEach((button) => {
        const label = button.querySelector("[data-loading-label]");
        const availableSubmitLabel = button.dataset.availableLabel || (isOmegaConfigurator ? "Order now" : "Add to cart");
        const soldOutSubmitLabel = button.dataset.soldOutLabel || "Sold out";

        button.disabled = !canOrder;

        if (label) {
          label.textContent = canOrder ? availableSubmitLabel : soldOutSubmitLabel;
        }
      });
    };

    const updateSummary = (selectedOption) => {
      if (!selectedOption) return;

      if (price && selectedOption.dataset.price) {
        price.textContent = selectedOption.dataset.price;
      }

      if (comparePrice) {
        const comparePriceText = selectedOption.dataset.comparePrice || "";
        comparePrice.textContent = comparePriceText;
        comparePrice.hidden = comparePriceText === "";
      }

      if (discountLabel) {
        const discountLabelText = selectedOption.dataset.discountLabel || "";
        discountLabel.textContent = discountLabelText ? `Discount: ${discountLabelText}` : "";
        discountLabel.hidden = discountLabelText === "";
      }

      const isAvailable = selectedOption.dataset.available === "true" && !selectedOption.disabled;
      const canOrder = isOmegaConfigurator || isAvailable;

      if (status) {
        status.textContent = canOrder ? (isOmegaConfigurator ? "Available for order" : "Available now") : "Currently unavailable";
      }

      if (fulfillmentNote) {
        fulfillmentNote.textContent = selectedOption.dataset.shippingTimeline || (isAvailable
          ? "Will be shipped in 3-5 days."
          : "Units will be ready around mid September - early October.");
      }

      if (shippingTimelineInput) {
        shippingTimelineInput.value = selectedOption.dataset.shippingTimeline || "";
      }

      if (fulfillmentTypeInput) {
        fulfillmentTypeInput.value = selectedOption.dataset.fulfillmentType || (isAvailable ? "in_stock" : "preorder");
      }

      syncSubmitButtons(canOrder);
    };

    const setVariant = (input) => {
      if (!input || input.disabled) return;

      select.value = input.value;
      select.dispatchEvent(new Event("change", { bubbles: true }));

      variantCards.forEach((card) => {
        const cardShell = card.closest(".tbm-variant-card");
        if (cardShell) {
          cardShell.classList.toggle("is-selected", card === input);
        }
      });

      updateSummary(input);
    };

    const getSelectedOptions = () => {
      const values = {};
      optionChoices.forEach((input) => {
        if (input.checked) {
          values[input.dataset.optionPosition] = input.value;
        }
      });
      return values;
    };

    const findMatchingVariant = () => {
      const selectedOptions = getSelectedOptions();
      return Array.from(select.options).find((option) => {
        return Object.keys(selectedOptions).every((position) => {
          return option.getAttribute(`data-option-${position}`) === selectedOptions[position];
        });
      });
    };

    const findVariantForOptions = (options) => {
      return Array.from(select.options).find((option) => {
        return Object.keys(options).every((position) => {
          return option.getAttribute(`data-option-${position}`) === options[position];
        });
      });
    };

    const findAvailableVariantForOptions = (options) => {
      return Array.from(select.options).find((option) => {
        const matches = Object.keys(options).every((position) => {
          return option.getAttribute(`data-option-${position}`) === options[position];
        });

        return matches && option.dataset.available === "true" && option.dataset.fulfillmentType !== "preorder" && !option.disabled;
      });
    };

    const updateOptionAvailability = () => {
      const selectedOptions = getSelectedOptions();

      optionChoices.forEach((input) => {
        const testOptions = Object.assign({}, selectedOptions);
        testOptions[input.dataset.optionPosition] = input.value;
        const matchingVariant = findVariantForOptions(testOptions);
        const availableVariant = findAvailableVariantForOptions(testOptions);
        const isSoldOut = !isOmegaConfigurator && (!matchingVariant || !availableVariant);
        const optionShell = input.closest(".tbm-omega-option");
        const meta = optionShell ? optionShell.querySelector("[data-option-meta]") : null;
        const optionHasInventory = Boolean(availableVariant);
        const optionHasVariant = Boolean(matchingVariant);
        const isColorOption = input.dataset.isColorOption === "true";
        const isPreorder = isOmegaConfigurator && isColorOption && optionHasVariant && !optionHasInventory;

        if (optionShell) {
          optionShell.classList.toggle("is-sold-out", isSoldOut);
          optionShell.classList.toggle("is-preorder", isPreorder);
        }

        if (meta) {
          if (isSoldOut) {
            meta.textContent = "Sold out";
          } else if (isPreorder) {
            meta.textContent = "Available for backorder";
          } else if (isColorOption && optionHasInventory) {
            meta.innerHTML = "Get Yours <b>Today</b>";
          } else if (isColorOption && optionHasVariant) {
            meta.textContent = "Available for backorder";
          } else {
            meta.textContent = input.dataset.optionName || "Available";
          }
        }
      });
    };

    const updateGraphicsPreview = () => {
      if (!graphicsPreview) return;

      const selectedGraphics = Array.from(optionChoices).find((input) => {
        const optionName = (input.dataset.optionName || "").toLowerCase();
        return input.checked && (optionName.includes("graphics") || optionName.includes("color"));
      });

      if (selectedGraphics && selectedGraphics.dataset.graphicsColor) {
        graphicsPreview.style.setProperty("--graphics-color", selectedGraphics.dataset.graphicsColor);
      }

      if (selectedGraphics && selectedGraphics.dataset.previewSrc && configImage) {
        configImage.src = selectedGraphics.dataset.previewSrc;
      }
    };

    const syncOptionVariant = () => {
      const matchedVariant = findMatchingVariant();

      if (matchedVariant) {
        select.value = matchedVariant.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        updateSummary(matchedVariant);
      } else {
        if (status) {
          status.textContent = isOmegaConfigurator ? "Available for order" : "Currently unavailable";
        }

        if (fulfillmentNote) {
          fulfillmentNote.textContent = isOmegaRexProduct
            ? "Units slated to arrive in January of 2027."
            : "Units will be ready around mid September - early October.";
        }

        if (comparePrice) {
          comparePrice.textContent = "";
          comparePrice.hidden = true;
        }

        if (discountLabel) {
          discountLabel.textContent = "";
          discountLabel.hidden = true;
        }

        syncSubmitButtons(isOmegaConfigurator);
      }

      optionChoices.forEach((input) => {
        const optionShell = input.closest(".tbm-omega-option");
        if (optionShell) {
          optionShell.classList.toggle("is-selected", input.checked);
        }

        const label = buyArea ? buyArea.querySelector(`[data-selected-option-label="${input.dataset.optionPosition}"]`) : null;
        if (input.checked && label) {
          label.textContent = input.value;
        }
      });

      updateGraphicsPreview();
      updateOptionAvailability();
    };

    const getSelectedChoiceValue = (matcher) => {
      const selected = Array.from(optionChoices).find((input) => {
        const optionName = (input.dataset.optionName || "").toLowerCase();
        return input.checked && matcher(optionName);
      });

      return selected ? selected.value : "";
    };

    select.addEventListener("change", () => {
      updateSummary(select.options[select.selectedIndex]);
    });

    if (form) {
      form.addEventListener("submit", (event) => {
        const selectedOption = select.options[select.selectedIndex];
        const submitButton = event.submitter && event.submitter.matches("button[type='submit']") && !event.submitter.dataset.orderCardProxySubmit
          ? event.submitter
          : document.querySelector(`button[type='submit'][form="${form.id}"]`) || form.querySelector("button[type='submit']");
        const isPreorderSelection = selectedOption?.dataset.fulfillmentType === "preorder";
        const isInStockSelection = selectedOption?.dataset.fulfillmentType === "in_stock";

        if (isBikeProduct && selectedOption) {
          if (isPreorderSelection && cartHasInStockBike) {
            event.preventDefault();
            showThemePopup({
              eyebrow: "Separate bike orders",
              message: "Preorder bikes and in-stock bikes need to be checked out separately. Please remove the in-stock bike from your cart before adding this preorder bike.",
            });
            return;
          }

          if (isInStockSelection && cartHasPreorderBike) {
            event.preventDefault();
            showThemePopup({
              eyebrow: "Separate bike orders",
              message: "In-stock bikes and preorder bikes need to be checked out separately. Please remove the preorder bike from your cart before adding this in-stock bike.",
            });
            return;
          }
        }

        if (!selectedOption || selectedOption.dataset.inventoryLimit === "") {
          setLoadingControl(submitButton, submitButton?.dataset.loadingText || "Adding...");
          return;
        }

        const inventoryLimit = Number(selectedOption.dataset.inventoryLimit);
        if (!Number.isFinite(inventoryLimit)) {
          setLoadingControl(submitButton, submitButton?.dataset.loadingText || "Adding...");
          return;
        }

        const cartQuantity = Number(selectedOption.dataset.cartQuantity || 0);
        const quantityInput = form.querySelector("input[name='quantity']");
        const requestedQuantity = Number(quantityInput?.value || 1);

        if (cartQuantity + requestedQuantity > inventoryLimit) {
          event.preventDefault();
          showStockNotice(
            inventoryLimit,
            getSelectedChoiceValue((optionName) => optionName.includes("graphics") || optionName.includes("color")),
            getSelectedChoiceValue((optionName) => optionName.includes("tire") || optionName.includes("tyre"))
          );
          return;
        }

        setLoadingControl(submitButton, submitButton?.dataset.loadingText || "Adding...");
      });
    }

    if (variantCards.length) {
      variantCards.forEach((input) => {
        input.addEventListener("change", () => setVariant(input));
      });
    }

    if (optionChoices.length) {
      optionChoices.forEach((input) => {
        input.addEventListener("change", syncOptionVariant);
      });

      syncOptionVariant();
    } else {
      updateSummary(select.options[select.selectedIndex]);
    }
  });

  document.querySelectorAll("[data-config-tabs]").forEach((tabs) => {
    const triggers = tabs.querySelectorAll("[data-config-tab]");
    const panels = tabs.querySelectorAll("[data-config-panel]");

    const activateTab = (trigger) => {
      const target = trigger.dataset.configTab;

      triggers.forEach((item) => {
        const isActive = item === trigger;
        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-selected", String(isActive));
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.configPanel === target;
        panel.classList.toggle("is-active", isActive);
        panel.hidden = !isActive;
      });
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        activateTab(trigger);
      });
    });
  });

  document.querySelectorAll("[data-choice-group]").forEach((group) => {
    const inputs = group.querySelectorAll("input[type='radio']");
    const configPanel = group.closest("[data-config-panel]");
    const choiceText = configPanel ? configPanel.querySelector(".tbm-omega-panel__choice") : null;

    const syncChoices = () => {
      inputs.forEach((input) => {
        const option = input.closest(".tbm-omega-option, .tbm-omega-swatch");
        if (option) {
          option.classList.toggle("is-selected", input.checked);
        }

        if (input.checked && choiceText) {
          choiceText.textContent = input.value;
        }
      });
    };

    inputs.forEach((input) => {
      input.addEventListener("change", syncChoices);
    });

    syncChoices();
  });

  document.querySelectorAll(".tbm-ride-tune__grid").forEach((group) => {
    const inputs = group.querySelectorAll(".tbm-ride-choice input[type='radio']");

    const syncRideChoices = () => {
      inputs.forEach((input) => {
        const choice = input.closest(".tbm-ride-choice");
        if (choice) {
          choice.classList.toggle("is-selected", input.checked);
        }
      });
    };

    inputs.forEach((input) => {
      input.addEventListener("change", syncRideChoices);
    });

    syncRideChoices();
  });

  document.addEventListener("click", (event) => {
    if (!event.target.closest(".tbm-custom-select")) {
      closeCustomSelects();
    }
  });

  document.querySelectorAll("[data-qty-control]").forEach((control) => {
    const input = control.querySelector("input[type='number']");
    const buttons = control.querySelectorAll("[data-qty-action]");

    if (!input || !buttons.length) return;

    const cartItem = control.closest("[data-cart-item]");
    const cartForm = control.closest(".tbm-cart");
    const inventoryLimit = cartItem && cartItem.dataset.inventoryLimit !== "" ? Number(cartItem.dataset.inventoryLimit) : Infinity;
    const cartOriginalTotal = Number(cartForm?.querySelector("[data-cart-original-total]")?.value || 0);
    const cartTotal = Number(cartForm?.querySelector("[data-cart-total]")?.value || 0);
    const cartDiscountRatio = cartOriginalTotal > cartTotal && cartOriginalTotal > 0 ? cartTotal / cartOriginalTotal : 1;
    const formatMoney = (cents) => {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(cents / 100);
    };

    const showInventoryNotice = () => {
      if (!Number.isFinite(inventoryLimit)) return;

      showStockNotice(inventoryLimit, cartItem?.dataset.configColor || "", cartItem?.dataset.configTire || "");
    };

    const updateCartPrices = () => {
      if (!cartItem || !cartForm) return;

      let subtotal = 0;
      let originalSubtotal = 0;

      cartForm.querySelectorAll("[data-cart-item]").forEach((item) => {
        const itemInput = item.querySelector("input[name='updates[]']");
        const unitPrice = Number(item.dataset.unitPrice || 0);
        const originalUnitPrice = Number(item.dataset.originalUnitPrice || unitPrice);
        const quantity = Number(itemInput?.value || 0);
        const linePrice = unitPrice * quantity;
        const originalLinePrice = originalUnitPrice * quantity;
        const display = item.querySelector("[data-line-price-display]");
        const compareDisplay = item.querySelector("[data-line-compare-price]");
        const finalDisplay = item.querySelector("[data-line-final-price]");
        const hasLineDiscount = originalLinePrice > linePrice;

        item.dataset.linePrice = String(linePrice);
        item.dataset.originalLinePrice = String(originalLinePrice);
        subtotal += linePrice;
        originalSubtotal += originalLinePrice;

        if (display) {
          display.classList.toggle("has-discount", hasLineDiscount);
        }

        if (compareDisplay) {
          compareDisplay.textContent = hasLineDiscount ? formatMoney(originalLinePrice) : "";
          compareDisplay.hidden = !hasLineDiscount;
        }

        if (finalDisplay) {
          finalDisplay.textContent = formatMoney(linePrice);
        } else if (display) {
          display.textContent = formatMoney(linePrice);
        }
      });

      const subtotalDisplay = cartForm.querySelector("[data-cart-subtotal]");
      const subtotalCompareDisplay = cartForm.querySelector("[data-cart-subtotal-compare]");
      const subtotalFinalDisplay = cartForm.querySelector("[data-cart-subtotal-final]");
      let discountedSubtotal = subtotal;

      if (cartDiscountRatio < 1 && originalSubtotal === subtotal) {
        discountedSubtotal = Math.round(originalSubtotal * cartDiscountRatio);
      }

      const hasSubtotalDiscount = originalSubtotal > discountedSubtotal;

      if (subtotalDisplay) {
        subtotalDisplay.classList.toggle("has-discount", hasSubtotalDiscount);
      }

      if (subtotalCompareDisplay) {
        subtotalCompareDisplay.textContent = hasSubtotalDiscount ? formatMoney(originalSubtotal) : "";
        subtotalCompareDisplay.hidden = !hasSubtotalDiscount;
      }

      if (subtotalFinalDisplay) {
        subtotalFinalDisplay.textContent = formatMoney(discountedSubtotal);
      } else if (subtotalDisplay) {
        subtotalDisplay.textContent = formatMoney(discountedSubtotal);
      }
    };

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const step = Number(input.step || 1) || 1;
        const min = input.min === "" ? -Infinity : Number(input.min);
        const inputMax = input.max === "" ? Infinity : Number(input.max);
        const max = Math.min(inputMax, inventoryLimit);
        const current = Number(input.value || 0);
        const next = button.dataset.qtyAction === "decrease" ? current - step : current + step;
        const clamped = Math.min(max, Math.max(min, next));

        if (button.dataset.qtyAction === "increase" && next > max) {
          showInventoryNotice();
        }

        input.value = String(clamped);
        input.dispatchEvent(new Event("change", { bubbles: true }));
        updateCartPrices();
      });
    });

    input.addEventListener("change", () => {
      const min = input.min === "" ? -Infinity : Number(input.min);
      const inputMax = input.max === "" ? Infinity : Number(input.max);
      const max = Math.min(inputMax, inventoryLimit);
      const current = Number(input.value || 0);
      const clamped = Math.min(max, Math.max(min, current));

      if (current > max) {
        showInventoryNotice();
      }

      input.value = String(clamped);
      updateCartPrices();
    });
  });

  document.querySelectorAll(".tbm-cart-item__remove").forEach((link) => {
    link.addEventListener("click", () => {
      setLoadingControl(link, "Removing...");
      const cartItem = link.closest("[data-cart-item]");
      if (cartItem) cartItem.classList.add("is-removing");
    });
  });

  document.querySelectorAll(".tbm-cart").forEach((cartForm) => {
    cartForm.addEventListener("submit", (event) => {
      const submitter = event.submitter || document.activeElement;
      const checkoutButton = submitter && submitter.matches("button[name='checkout']")
        ? submitter
        : cartForm.querySelector("button[name='checkout']");
      const hasMixedBikeFulfillment = cartForm.querySelector("[data-cart-has-mixed-bike-fulfillment]")?.value === "true";

      if (submitter && submitter.matches("button[name='checkout']") && hasMixedBikeFulfillment) {
        event.preventDefault();
        showThemePopup({
          eyebrow: "Separate bike orders",
          message: "Preorder bikes and in-stock bikes must be checked out separately. Please update your cart before continuing to checkout.",
        });
        return;
      }

      setLoadingControl(checkoutButton, "Loading checkout...");
    });
  });

  document.querySelectorAll(".tbm-omega-order-card").forEach((orderCard, index) => {
    const form = orderCard.closest("form");

    if (!form || orderCard.parentElement === document.body) return;

    if (!form.id) {
      form.id = `tbm-omega-product-form-${index + 1}`;
    }

    orderCard.querySelectorAll("button, input, select, textarea").forEach((control) => {
      control.setAttribute("form", form.id);
    });

    const submitButton = orderCard.querySelector("button[type='submit']");
    if (submitButton) {
      let proxySubmit = form.querySelector("[data-order-card-proxy-submit]");

      if (!proxySubmit) {
        proxySubmit = document.createElement("button");
        proxySubmit.type = "submit";
        proxySubmit.className = "tbm-visually-hidden-submit";
        proxySubmit.setAttribute("aria-hidden", "true");
        proxySubmit.tabIndex = -1;
        proxySubmit.dataset.orderCardProxySubmit = "";
        form.appendChild(proxySubmit);
      }

      submitButton.addEventListener("click", (event) => {
        if (submitButton.disabled || submitButton.classList.contains("is-loading")) return;

        event.preventDefault();
        submitButton.classList.remove("is-clicked");
        void submitButton.offsetWidth;
        submitButton.classList.add("is-clicked");
        proxySubmit.click();
      });
    }

    orderCard.classList.add("is-lifted");
    document.body.appendChild(orderCard);
  });
});
